import {
  MAX_FILE_SIZE_BYTES,
  UPLOAD_FILE_TYPES_ACCEPT,
} from "~/api/v2/constants";
import type { FileType } from "~/api/types";

export type FileValidationError = "unsupported_type" | "file_too_large";

const ALLOWED_EXTENSIONS = UPLOAD_FILE_TYPES_ACCEPT.split(",").map((ext) =>
  ext.replace(".", "").toLowerCase(),
);

export function validateFile(
  file: File,
  allowedExtensions: string[] = ALLOWED_EXTENSIONS,
): FileValidationError | null {
  const extension = file.name.split(".").pop()?.toLowerCase();
  if (!extension || !allowedExtensions.includes(extension)) {
    return "unsupported_type";
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return "file_too_large";
  }
  return null;
}

export function getExpectedExtension(fileType: FileType): string {
  return fileType === "sfdt" ? "docx" : fileType;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} kB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
